module.exports = __webpack_public_path__ + "fonts/Cabin-Bold_dot.otf";